import Detail from './Detail';
export default Detail;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/components/ListOrders/components/Detail/index.ts